import { Pagination } from "@mui/material";

import "./style.less";

interface IMyPagination {
	offset: number;
	total: number;
	perPage: number;
	onPageChange?: (page: number) => void;
}

export default function MyPagination({
	offset,
	total,
	perPage,
	onPageChange = () => {},
}: IMyPagination) {
	const curPage = (offset / perPage >>> 0) + 1;
	const maxPages = (total / perPage >>> 0) + 1;

	function onPaginationChange(event: any, page: number) {
		if (page !== curPage) {
			onPageChange(page);
		}
	}

	return <div className="paginationCont">
		<Pagination count={maxPages} color="primary" onChange={onPaginationChange} page={curPage} variant="outlined" />
	</div>;
}
